import { render, staticRenderFns } from "./SupportWidget.vue?vue&type=template&id=149c61b3&scoped=true"
import script from "./SupportWidget.vue?vue&type=script&lang=js"
export * from "./SupportWidget.vue?vue&type=script&lang=js"
import style0 from "./SupportWidget.vue?vue&type=style&index=0&id=149c61b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c61b3",
  null
  
)

export default component.exports